import React, { useEffect } from "react";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";

const ImageModal = ({ open, src, title, onClose }) => {
    useEffect(() => {
        if (!open) return undefined;

        const onKey = e => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);

        // Keep the page behind the overlay from scrolling
        const previous = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = previous;
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-label={title || "Image preview"}
            onClick={onClose}
            className="fixed inset-0 z-[100] flex items-center justify-center
                       bg-canvas-deep/85 p-4 backdrop-blur-sm animate-rise sm:p-5"
        >
            <div
                onClick={e => e.stopPropagation()}
                className="relative max-h-full w-full max-w-3xl overflow-hidden rounded-frame
                           border border-line bg-canvas shadow-frame"
            >
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close image"
                    className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center
                               rounded-full border border-line bg-canvas-deep/80 text-ink-dim
                               transition-colors duration-200 hover:border-accent hover:text-accent"
                >
                    <CloseRoundedIcon style={{ fontSize: 19 }} />
                </button>

                <div className="flex flex-col items-center gap-4 p-5 pt-14 sm:gap-5 sm:p-8 sm:pt-8">
                    <img
                        src={src}
                        alt={title || "Preview"}
                        className="max-h-[60vh] w-auto max-w-full object-contain sm:max-h-[70vh]"
                    />
                    {title && (
                        <p className="text-center font-mono text-[11px] uppercase tracking-[0.14em] text-ink-dim">
                            {title}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ImageModal;
